import { TreatmentType } from '../enums';

export class Arguments {
    CustomerID: number;
    PracticeID: number;
    Schedulers: string; // 1 or 1,2,3...
    Branches: string; // 1 or 1,2,3..
    Pricelist: string; // 1 or 1,2,3...
    Type: TreatmentType; // Treatment = 1, Product = 2, Series = 3, Plan = 4
    FilterText: string;
}